import { useContext } from "react";
import { KBContext } from "../..";

import { isFeatureEnabled } from "../../../utils";
import { FTR_SUB_CATEGORIES } from "../../../Constants";

export const useSubCategoriesFeature = () => {

    // KBContext defaults to [] (see Context/index.js); guard so a missing
    // provider yields an empty object rather than `undefined` field access.
    const context = useContext(KBContext);
    const { availableFeatures } = (context && !Array.isArray(context)) ? context : {};

    const isSubCategoriesFeatureEnabled = isFeatureEnabled(FTR_SUB_CATEGORIES, availableFeatures);

    return { isSubCategoriesFeatureEnabled };
}